import Contact from "../components/contactt/contact"
function Contactpage(){
    return(
        <>
        <Contact/>
        </>
    )
}
export default Contactpage